import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DataRequestType } from '@resideo/web-integration-services-api-client';

import { RisError } from 'types/types';

import { useRisClient } from './useRisClient';

interface UseCloseAccountOptions {
  onError: () => void;
  onConflict: (message: string) => void;
}

export const useCloseAccount = ({
  onError,
  onConflict,
}: UseCloseAccountOptions) => {
  const { client } = useRisClient();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async () => {
      await client.reports.reportsCreateDataRequest({
        type: DataRequestType.DATA_ERASURE,
      });
    },
    onError: (resp: RisError) => {
      if (resp.status === 409) {
        onConflict(t('privacy.requestMyData.errors.entityConflictMessage'));
      } else {
        onError();
      }
    },
    onSuccess: async () => {
      navigate('/sign-out');
    },
  });
};
